export const state = {
    pinnedMenu: []
};
